<template>
  <div>authenticate</div>
</template>

<script>
export default {
  beforeCreate() {
    let queryParams = "";
    if (this.$route.query.redirect_wb) {
      queryParams += queryParams == "" ? `?redirect_wb=${encodeURIComponent(this.$route.query.redirect_wb)}` : `&redirect_wb=${encodeURIComponent(this.$route.query.redirect_wb)}`;
    }
    if (this.$route.query.action) {
      queryParams += queryParams == "" ? `?action=${this.$route.query.action}` : `&action=${this.$route.query.action}`;
    }
    if (this.$route.query.type) {
      queryParams += queryParams == "" ? `?type=${this.$route.query.type}` : `&type=${this.$route.query.type}`;
    }
    if (this.$route.query.atk && this.$route.query.rtk) {
      localStorage.setItem("apiToken", this.$route.query.atk);
      localStorage.setItem("refreshToken", this.$route.query.rtk);
      if (this.$route.query.first_time) {
        localStorage.setItem("firstTime", this.$route.query.first_time);
      } else {
        localStorage.setItem("firstTime", '0');
      }
      localStorage.setItem("processing", false);
      this.$router.push(`/${queryParams}`);

    } else if (localStorage.getItem("apiToken") && localStorage.getItem("refreshToken")) {
      localStorage.setItem("processing", false);
      this.$router.push(`/${queryParams}`);

    } else {
      // alert('no login');
      // this.$router.push("logout");
    }
  },
};
</script>

<style>
</style>